// Default settings
// Selectors
var gSelectorTriangleMain = '.triangleMain';
var gSelectorTriangleSession = '.triangleSession';
var gSelectorTriangleHeadline = '.triangleHeadline';
var gSelectorNewsItem = 'td.item'; // container of individual item news
var gSelectorTitleOfItems = '.title';
var gSelectorCollapsablePriority = '.priority0, .priority1, .priority2, .priority3, .priority4, .priority5';
// css classes
var gClassCollapseSection = 'collapseSections'; // class of the elements that can be collapsed/expanded
var gClassCollapsedList = 'collapsedAll'; // hides all items
var gClassCollapsedItem = 'collapsedItem'; //hides collapsed element
var gClassTitleOfCollapsedItem = 'list_titleOfCollapsedItem';

var gNumberOfItems = -1; // number of individual news items
var gMinItemsTriggerCollapse = 2; // minimum amount of articles needed to trigger 'collapse all'

var gMinWidthBigViewport = 700;

var gSpeedAutomaticCollapse = 2500;
var gSpeedUserAction = 1000;

var gAllHeadlines;
var gAllLinksHeadline;

// flags
var gIsCollapsed = false;

$(document).ready(function () {

	gNumberOfItems = $(gSelectorNewsItem).length;

	var iWidthViewport = viewport().width;
	
	// extra attribute for all the links in the headlines
	gAllHeadlines = document.getElementsByClassName('title');
	var length = gAllHeadlines.length;
	for (var i = 0; i < length; i++) {
		gAllLinksHeadline = gAllHeadlines[i].getElementsByTagName('a');
		var numberLinks = gAllLinksHeadline.length;
		for (var j = 0; j < numberLinks; j++) {
			gAllLinksHeadline[j].setAttribute('org_title',gAllLinksHeadline[j].title);
		}
	}
	
	// Guest mode must show expanded items if the viewport is wide enough (consistency with site for logged in users)
	if (iWidthViewport < gMinWidthBigViewport && $('.bodyGuestMode').length == 1) {
		$('body').addClass(gClassCollapsedList);
	}

	// Collapse news items if respective css class is present and the threshold is exceeded.
	if ($('.'+gClassCollapsedList).length == 1) {
		
		if (gNumberOfItems != -1 && gNumberOfItems >= gMinItemsTriggerCollapse) {
			collapseAllNewsItems(gSpeedAutomaticCollapse);
		} else {
			// if the threshold is not exceeded the user setting can be different to the current displayed state,
			// avoid inconsistency when the user clicks on the big triangle (persistent)
			$('body').removeClass(gClassCollapsedList);
		}
		
	}
	
	handleMoreLessOption($("."+gClassCollapseSection));
	
	initJsScroll();

	// All news items of the main table are opened/closed when the triangle is clicked
	$(document).on('click',gSelectorTriangleMain, function(e) {
		if (gIsCollapsed) {
			expandAllNewsItems(gSpeedUserAction);
		} else {
			collapseAllNewsItems(gSpeedUserAction);
		}
	});
	
	// All news items of a dynamically loaded (by scrolling) session are opened/closed when the triangle is clicked
	$(document).on('click',gSelectorTriangleSession, function(e) {
		
		var $sessionContainer = $(this).closest('.jscroll-added');
		
		if ($sessionContainer.hasClass(gClassCollapsedList)) {
			expandAllNewsItemsSession($sessionContainer,gSpeedUserAction);
		} else {
			collapseAllNewsItemsSession($sessionContainer,gSpeedUserAction);
		}
	});

	// expand individual news item from the main table when its title/triangle is clicked
	$('div.mainTable').on('click','.'+gClassTitleOfCollapsedItem, function(e) {
		e.preventDefault();
		expandNewsItem($(this), gSpeedUserAction);
	});
	
	// collapse individual news item  from the main table  when its triangle is clicked while its content is expanded
	$('div.mainTable').on('click','.triangleHeadline', function(e) {

		var $thisHeadline = $(this).closest(gSelectorTitleOfItems);
		
		if (!$thisHeadline.hasClass(gClassTitleOfCollapsedItem)) {
			collapseNewsItem($thisHeadline, gSpeedUserAction);
		}
	});

	// expand individual news item of a dynamically loaded (by scrolling) session when its title/triangle is clicked
	// this handler works for dynamically added elements
	$(document).on('click','div.jscroll-added .'+gClassTitleOfCollapsedItem, function(e) {
		e.preventDefault();
		expandNewsItemAddedSession($(this), gSpeedUserAction);
	});
	
	// collapse individual news item of a dynamically loaded (by scrolling) session when its triangle is clicked
	// while its content is expanded. This handler works for dynamically added elements
	$(document).on('click','div.jscroll-added .triangleHeadline', function(e) {
		
		var $thisHeadline = $(this).closest(gSelectorTitleOfItems);
		
		if (!$thisHeadline.hasClass(gClassTitleOfCollapsedItem)) {
			collapseNewsItemAddedSession($thisHeadline, gSpeedUserAction);
		}
	});

});

// Expand ALL news items
// IN: speed - speed of the animation that rotates the triangles
//UIT:
function expandAllNewsItems(speed) {

	$('body').removeClass(gClassCollapsedList);
	
	$(gSelectorTriangleMain).css('color', '');
	
	// mark all the little triangles as expanded
	$('.mainTable '+gSelectorTriangleHeadline).removeClass('triangleOfCollapsedItem');

	$('.mainTable .'+gClassCollapseSection).removeClass(gClassCollapsedItem);

	gIsCollapsed = false;

	rotateElementAnimation(-90, 0, $(gSelectorTriangleMain), speed);
	//Only rotate the triangle of the collapsed items (some might have been expanded individually)
	rotateElementAnimation(-90, 0, $('.mainTable .'+gClassTitleOfCollapsedItem+' '+gSelectorTriangleHeadline), speed);

	$(gSelectorTriangleMain).attr('title','Alleen koppen');

	// necessary for items with many bullets (e.g. weather, liveblog)
	if (gNumberOfItems > 1) {
		$('.mainTable .removeShowLines').show();
	}
	
	// enable elements below the image (sharing, time, etc)
	$('.mainTable .img-extra-icons').show();
	$('.mainTable .img-small-icons').hide();
	
	$('.mainTable '+gSelectorTitleOfItems).removeClass(gClassTitleOfCollapsedItem);
	
	// show title on hover
	var length = gAllLinksHeadline.length;
	for (var i = 0; i < length; i++) {
		gAllLinksHeadline[i].setAttribute('title',gAllLinksHeadline[i].getAttribute('org_title'));
	}

}


// Collapse all items that match gSelectorCollapsablePriority. It hides news content so that only the title is visible.
// IN: speed - speed of the animation that rotates the triangles
//UIT:
function collapseAllNewsItems(speed) {

	$(gSelectorTriangleMain).css('color', '');

	$('body').addClass(gClassCollapsedList);

	$('.mainTable '+gSelectorCollapsablePriority).parent().each(function() {
		$(this).find("."+gClassCollapseSection).addClass(gClassCollapsedItem);
		// necessary for items with many bullets (e.g. weather, liveblog) that have a meer/minder option
		$(this).find(".removeShowLines").hide();
	});
	
	$('.mainTable '+gSelectorCollapsablePriority).addClass(gClassTitleOfCollapsedItem);

	rotateElementAnimation(0, -90, $('.mainTable '+gSelectorTriangleHeadline).not('.triangleOfCollapsedItem'), speed);

	gIsCollapsed = true;

	rotateElementAnimation(0, -90, $(gSelectorTriangleMain), speed);
	$(gSelectorTriangleMain).attr('title','Nieuws met samenvatting');
	
	// enable elements below the image (sharing, time, etc)
	$('.mainTable .img-extra-icons').hide();
	$('.mainTable .img-small-icons').show();
	
	// mark all the little triangles as collapsed
	$('.mainTable '+gSelectorTriangleHeadline).addClass('triangleOfCollapsedItem');
	
	// don't show tooltip on hover
	var length = gAllLinksHeadline.length;
	for (var i = 0; i < length; i++) {
		gAllLinksHeadline[i].setAttribute('title','');
	}
}


// Expand individual news item
// IN: item - html element that must trigger expansion of the news item
//     speed - speed of the animation that rotates the triangles
//UIT:
function expandNewsItem(item, speed) {

	item.closest(gSelectorNewsItem).find("."+gClassCollapseSection).removeClass(gClassCollapsedItem);

	item.removeClass(gClassTitleOfCollapsedItem);

	// necessary for items with many bullets (e.g. weather, liveblog)
	if (gNumberOfItems > 1) {
		item.closest(gSelectorNewsItem).find(".removeShowLines").show();
	}
	
	// enable elements below the image (sharing, time, etc)
	var $tr = item.closest('tr');
	$tr.find('.img-extra-icons').show();
	$tr.find('.img-small-icons').hide();
	
	$tr.find(gSelectorTriangleHeadline).removeClass('triangleOfCollapsedItem');
	
	rotateElementAnimation(-90, 0, $tr.find(gSelectorTriangleHeadline), speed);
	
	// if general state is 'collapsed' but all items are now expanded
	if ($('.mainTable .triangleOfCollapsedItem').length == 0) {
		$(gSelectorTriangleMain).css('color','');
		if (gIsCollapsed === true) {
			rotateElementAnimation(-90, 0, $(gSelectorTriangleMain), speed);
			gIsCollapsed = false;
		}
	} else {
		$(gSelectorTriangleMain).css('color','#DADADA');
	}
	
	// let the title attribute appear on a tooltip on hover
	var $linksInHeadline = item.find('a');
	$linksInHeadline.each(function() {
		$(this).attr('title', $(this).attr('org_title'));
	});
}


// Collapse individual news item
// IN: titleElement - container of the headline
//     speed - speed of the animation that rotates the triangles
//UIT:
function collapseNewsItem($titleElement, speed) {

	var $thisTriangle = $titleElement.find(gSelectorTriangleHeadline);

	$thisTriangle.addClass('triangleOfCollapsedItem');
	
	rotateElementAnimation(0, -90, $titleElement.find('.triangleHeadline'), speed);

	$titleElement.closest(gSelectorNewsItem).find('.'+gClassCollapseSection).addClass(gClassCollapsedItem);

	$titleElement.addClass(gClassTitleOfCollapsedItem);
	
	// hide elements below the image (sharing, time, etc)
	var $tr = $titleElement.closest('tr');
	$tr.find('.img-extra-icons').hide();
	$tr.find('.img-small-icons').show();
	$tr.find(".removeShowLines").hide();

	// if general state is 'expanded' but all items are now collapsed
	if (gNumberOfItems == $('.mainTable .triangleOfCollapsedItem').length) {
		$(gSelectorTriangleMain).css('color','');
		if (gIsCollapsed === false) {
			rotateElementAnimation(0, -90, $(gSelectorTriangleMain), speed);
			gIsCollapsed = true;
		}
	} else {
		$(gSelectorTriangleMain).css('color','#DADADA');
	}
	
	// this headline cannot show tooltips on hover
	var $linksInHeadline = $titleElement.find('a');
	$linksInHeadline.each(function() {
		$(this).attr('title', '');
	});
}


// Gets viewport width and height
// IN:
//UIT: object with two properties: width and height. Usage: viewport().width
function viewport() {
	var e = window, a = 'inner';
	//Cross browser? http://www.quirksmode.org/mobile/tableViewport.html
	if (!('innerWidth' in window )) {
		a = 'client';
		e = document.documentElement || document.body;
	}
	return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
}

// Animation for css transform to rotate element
// IN: initialDegree: initial position of the element
//     finalDegree: final position of the element
//     $element: element to be transformed
//     timeSpan: duration of the animation in miliseconds
//UIT:
function rotateElementAnimation(initialDegree, finalDegree, $element, timeSpan) {

	$({deg: initialDegree}).animate({deg: finalDegree}, {
		duration: timeSpan,
		step: function(now) {
			// in the step-callback (fired each step of the animation) 'now' contains the current animation-position
			$element.css({
				transform: 'rotate(' + now + 'deg)'
			});
		}
	});
}


// Save setting that determines whether the items must be collapsed for the current device
// IN: deviceID
//UIT:
function toggleCollapse(deviceID) {

	var xmlhttp = new XMLHttpRequest();

	// if items are collapsed then the body has specific class (see gClassCollapsedList)
	if ($('body').hasClass(gClassCollapsedList)) {
		xmlhttp.open('GET','/ajax/collapse_items?deviceid='+deviceID+'&value=0', true);
	} else {
		xmlhttp.open('GET','/ajax/collapse_items?deviceid='+deviceID+'&value=1', true);
	}

	xmlhttp.send();

}


// Modifies the number of sections that are shown of an item when its 'more/less' option is clicked.
// IN: item - element that was clicked
//UIT:
function collapseItem(item) {
	
	var $container = $(item).closest('td');

	// the iframe version doesn't use a table
	if ($container.length == 0) {
		$container = $(item).closest('.article');
	}
	
	var element = $('ul.collapseSections li', $container);
	
	var totalSections = element.length;
	var shownSections = $container.find('ul.collapseSections').data('show') - 1; // include title
	
	for (var i = totalSections; shownSections <= i; i--) {
		
		if (element.eq(i).hasClass('isOpen')) {
			element.eq(i).slideUp();
			element.eq(i).removeClass('isOpen');
			$(item).find('span').html('Meer');
		} else {
			element.eq(i).slideDown();
			element.eq(i).addClass('isOpen');
			$(item).find('span').html('Minder');
		}
	}
	
}


// Expand all news items of a session
// IN: $container - element that contains all the items of the session
//     speed - speed of the animation that rotates the triangles
//UIT:
function expandAllNewsItemsSession($container, speed) {
	
	var iItemsSession = $container.find(gSelectorNewsItem).length;

	$container.removeClass(gClassCollapsedList);
	
	$container.find(gSelectorTriangleSession).css('color', '');
	
	// mark all the little triangles as expanded
	$container.find(gSelectorTriangleHeadline).removeClass('triangleOfCollapsedItem');

	$container.find("."+gClassCollapseSection).removeClass(gClassCollapsedItem);

	rotateElementAnimation(-90, 0, $container.find(gSelectorTriangleSession), speed);
	//Only rotate the triangle of the collapsed items (some might have been expanded individually)
	rotateElementAnimation(-90, 0, $container.find('.'+gClassTitleOfCollapsedItem+' '+gSelectorTriangleHeadline), speed);

	$container.find(gSelectorTriangleSession).attr('title','Alleen koppen');

	if (iItemsSession > 1) {
		// necessary for items with many bullets (e.g. weather, liveblog)
		$container.find('.removeShowLines').show();
	}
	
	// enable elements below the image (sharing, time, etc)
	$container.find('.img-extra-icons').show();
	$container.find('.img-small-icons').hide();
	
	$container.find(gSelectorTitleOfItems).removeClass(gClassTitleOfCollapsedItem);
	
	//TODO: show title on hover
}


// Collapse all items of a session.
// IN: $container - element that contains all the items of the session
//     speed - speed of the animation that rotates the triangles
//UIT:
function collapseAllNewsItemsSession($container, speed) {

	$container.find(gSelectorTriangleSession).css('color', '');

	$container.addClass(gClassCollapsedList);

	$container.find('.'+gClassCollapseSection).addClass(gClassCollapsedItem);
	$container.find('.removeShowLines').hide();
	$container.find(gSelectorCollapsablePriority).addClass(gClassTitleOfCollapsedItem);

	rotateElementAnimation(0, -90, $container.find(gSelectorTriangleHeadline).not('.triangleOfCollapsedItem'), speed);

	rotateElementAnimation(0, -90, $container.find(gSelectorTriangleSession), speed);
	$container.find(gSelectorTriangleSession).attr('title','Nieuws met samenvatting');
	
	// enable elements below the image (sharing, time, etc)
	$container.find('.img-extra-icons').hide();
	$container.find('.img-small-icons').show();
	
	// mark all the little triangles as collapsed
	$container.find(gSelectorTriangleHeadline).addClass('triangleOfCollapsedItem');
	
	//TODO: don't show tooltip on hover
}

// Handle the 'more/less' option that appears on items  with attribute data-show > number of bullets
// IN: $collapsableElements - elements that can be collapsed/expanded
//UIT:
function handleMoreLessOption($collapsableSections) {
	
	if ($collapsableSections.length == 1) {

		$('.removeShowLines').hide();

	} else if ($collapsableSections.length > 1) {
		
		$collapsableSections.each(function(i) {
			
			var $container = $(this);
			
			if ($container.data('show') == 0) {
				return;
			}
			
			var iArticleID    = $container.data('article');
			var shownSections = $container.data('show') - 1;  // include title
			var totalSections = $('li', $container).length;
			
			for (var j = totalSections; shownSections <= j; j--) {
				$('li', $container).eq(j).hide();
			}
		});
	}
}


// Expand individual news item of a dynamically loaded (by scrolling) session
// IN: item - html element that must trigger expansion of the news item
//     speed - speed of the animation that rotates the triangles
//UIT:
function expandNewsItemAddedSession(item, speed) {

	item.closest(gSelectorNewsItem).find("."+gClassCollapseSection).removeClass(gClassCollapsedItem);

	item.removeClass(gClassTitleOfCollapsedItem);
	
	// enable elements below the image (sharing, time, etc)
	var $tr = item.closest('tr');
	$tr.find('.img-extra-icons').show();
	$tr.find('.img-small-icons').hide();
	
	$tr.find(gSelectorTriangleHeadline).removeClass('triangleOfCollapsedItem');

	var $sessionContainer = $tr.closest('.jscroll-added');
	var numberItemsSession = $sessionContainer.find('tr').length;
	var $triangleSession = $sessionContainer.find(gSelectorTriangleSession);
	
	// necessary for items with many bullets (e.g. weather, liveblog)
	if (numberItemsSession > 1) {
		item.closest(gSelectorNewsItem).find(".removeShowLines").show();
	}

	rotateElementAnimation(-90, 0, $tr.find(gSelectorTriangleHeadline), speed);
	
	// if general state of the added session is 'collapsed' but all items are now expanded
	if ($sessionContainer.find('.triangleOfCollapsedItem').length == 0) {
		$triangleSession.css('color', '');
		rotateElementAnimation(-90, 0, $triangleSession, speed);
	} else {
		$triangleSession.css('color','#DADADA');
	}
	
	// let the title attribute appear on a tooltip on hover
	var $linksInHeadline = item.find('a');
	$linksInHeadline.each(function() {
		$(this).attr('title', $(this).attr('org_title'));
	});
}


// Collapse individual news item of a dynamically loaded (by scrolling) session
// IN: titleElement - container of the headline
//     speed - speed of the animation that rotates the triangles
//UIT:
function collapseNewsItemAddedSession($titleElement, speed) {

	var $thisTriangle = $titleElement.find(gSelectorTriangleHeadline);

	$thisTriangle.addClass('triangleOfCollapsedItem');
	
	rotateElementAnimation(0, -90, $titleElement.find('.triangleHeadline'), speed);

	$titleElement.closest(gSelectorNewsItem).find('.'+gClassCollapseSection).addClass(gClassCollapsedItem);

	$titleElement.addClass(gClassTitleOfCollapsedItem);
	
	// hide elements below the image (sharing, time, etc)
	var $tr = $titleElement.closest('tr');
	$tr.find('.img-extra-icons').hide();
	$tr.find('.img-small-icons').show();
	$tr.find(".removeShowLines").hide();

	var $sessionContainer = $tr.closest('.jscroll-added');
	var numberItemsSession = $sessionContainer.find('tr').length;
	var $triangleSession = $sessionContainer.find(gSelectorTriangleSession);

	// if general state of the added session is 'expanded' but all its items are now collapsed
	if (numberItemsSession == $sessionContainer.find('.triangleOfCollapsedItem').length) {
		$triangleSession.css('color', '');
		rotateElementAnimation(0, -90, $triangleSession, speed);
	} else {
		$triangleSession.css('color','#DADADA');
	}
	
	// this headline cannot show tooltips on hover
	var $linksInHeadline = $titleElement.find('a');
	$linksInHeadline.each(function() {
		$(this).attr('title', '');
	});
}

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
